import ApplicationController from '../support/application_controller'
import I18n                  from '../support/i18n'

export default class extends ApplicationController {

  static targets = [
    'count',
    'doctor',
    'countLabel'
  ]

  doctorTargetConnected() {
    this.#updateCount()
  }

  doctorTargetDisconnected() {
    this.#updateCount()
  }

  // ==== Actions

  // ==== Getters

  get onlineDoctorsCount() {
    return parseInt(this.countTarget.textContent, 10)
  }

  // ==== Setters

  set onlineDoctorsCount(value) {
    this.countTarget.textContent = value
  }

  // ==== Private

  #updateCount() {
    this.onlineDoctorsCount = this.doctorTargets.length
    this.#updateCountLabel()
  }

  #updateCountLabel() {
    if (!this.hasCountLabelTarget) return

    this.countLabelTarget.textContent = I18n.t('app.doctors_online_label', {
      count: this.onlineDoctorsCount
    })
  }

}
